<template>
    <div class="card card-basic card--blue d-flex flex-column">
        <div class="card__text">
            <div class="card__text__top">
                <span class="card__subject">
                    <a :href="cardData.url">
                        {{ nameWithAcronym }}
                    </a>
                </span>
                <h2>{{ cardData.shoptName }}</h2>
                <ul class="mb-2 list-unstyled card__list font-italic">
                    <li v-for="theme in cardData.themes" :key="theme.id">
                        {{ theme.name }}
                    </li>
                </ul>
            </div>
        </div>
        <div
            v-if="cardData.description"
            class="card__bottom bg--blue align-self-end"
        >
            <div v-collapse-content>
                <p class="color--white font-italic mt-3 text-fade">
                    {{ cardData.description }}
                    <br v-if="cardData.descriptionEn" />
                    {{ cardData.descriptionEn }}
                </p>
                <p
                    v-if="cardData.descriptionEn"
                    class="color--white font-italic mt-2 text-fade"
                >
                    {{ cardData.descriptionEn }}
                </p>
            </div>
            <div v-collapse-toggle class="card__bottom__button">
                <div
                    class="card__bottom__button__content d-block w-100 position-relative"
                >
                    <span class="card__bottom__read-more">Meer</span
                    ><span
                        class="icon-angle-down card__bottom__button__content__icon"
                    ></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        cardData: {
            type: Object,
            default() {
                return {};
            }
        },
        readMore: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    computed: {
        nameWithAcronym() {
            return ` ${this.cardData.name} (${this.cardData.shortName})`;
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@/scss/helpers/_extensions.scss';

a .card:hover {
    transform: none;
    @extend %box-shadow;
}

a .card:hover .card__bottom__button {
    height: auto;
}

.card__bottom {
    position: relative;
    background: none;
    padding: 6px 15px 6px 30px;
}

.card__bottom__button {
    height: auto;
    background: none;
    padding: 0;
}

.card__bottom__button__content {
    opacity: 1;
}

.card__bottom__button__content__icon {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    font-size: 30px;
}

.v-collapse-content {
    pointer-events: none;
    max-height: 0;
    -webkit-transition: max-height 0.3s ease-out;
    transition: max-height 0.3s ease-out;
    overflow: hidden;
    padding: 0;
}

.v-collapse-content p {
    -webkit-transition: opacity 0.3s;
    transition: opacity 0.3s;
    opacity: 0;
}

.v-collapse-content-end {
    -webkit-transition: max-height 0.3s ease-in;
    transition: max-height 0.3s ease-in;
    max-height: 500px;
}

.v-collapse-content-end p {
    opacity: 1;
}

.v-collapse-content-end + .card__bottom__button {
    position: absolute;
    top: 0;
    width: 100%;
    left: 0;
    height: 50px;
}

.v-collapse-content-end + .card__bottom__button .card__bottom__read-more {
    -webkit-transition: opacity 0.3s;
    transition: opacity 0.3s;
    opacity: 0;
    padding-left: 30px;
}

.v-collapse-content-end
    + .card__bottom__button
    .card__bottom__button__content__icon {
    right: 15px;
    -webkit-transform: translateY(-50%) rotate(180deg);
    transform: translateY(-50%) rotate(180deg);
}
</style>
